// AUTO-GENERATED by scripts/buildPairedCampuses.js — DO NOT EDIT BY HAND.
// Source: TEA Paired Campuses List(s). Keyed by accountability rating year.
// TEA pairs campuses serving only non-STAAR-tested grades (PK, K, 1, 2) with a
// feeder campus; the paired campus is assigned its feeder's rating
// (Accountability Manual, Ch. 7 Pairing). Keys/values are 9-digit
// county-district-campus numbers (non-tested campus -> feeder campus).
// Regenerate: node scripts/buildPairedCampuses.js <path-to-xlsx> <ratingYear>

export const PAIRED_CAMPUSES_BY_YEAR = {
  '2026': {
    '001903101': '001903102',
    '001907101': '001907107',
    '001907102': '001907107',
    '001908102': '001908101',
    '002901105': '002901101',
    '003902101': '003902102',
    '003903124': '003903121',
    '003903125': '003903000',
    '003903127': '003903121',
    '003903130': '003903122',
    '003903131': '003903129',
    '003905101': '003905103',
    '004901103': '004901101',
    '007902102': '007902101',
    '007904103': '007904101',
    '007905105': '007905103',
    '007906101': '007906102',
    '009901103': '009901101',
    '011904102': '011904101',
    '013901105': '013901101',
    '014901102': '014901101',
    '014901103': '014901101',
    '014903119': '014903000',
    '014909101': '014909117',
    '014910103': '014910101',
    '015901102': '015901104',
    '015905118': '015905106',
    '015905125': '015905109',
    '015905140': '015905106',
    '015905141': '015905106',
    '015907106': '015907117',
    '015907202': '015907126',
    '015907240': '015907138',
    '015909103': '015909101',
    '015910148': '015910000',
    '015911109': '015911104',
    '015915668': '015915000',
    '015916126': '015916112',
    '015916127': '015916110',
    '015917107': '015917000',
    '019907107': '019907108',
    '019907115': '019907000',
    '019908102': '019908103',
    '019912102': '019912000',
    '020901106': '020901107',
    '020905104': '020905116',
    '020907106': '020907000',
    '024901103': '024901101',
    '024901105': '024901101',
    '025909102': '025909101',
    '027903101': '027903104',
    '028902102': '028902104',
    '030902101': '030902103',
    '031903124': '031903000',
    '031909101': '031909102',
    '032902104': '032902103',
    '034901107': '034901106',
    '036901201': '036901000',
    '036902302': '036902104',
    '036903103': '036903101',
    '037907103': '037907102',
    '043901201': '043901000',
    '043903103': '043903104',
    '043904101': '043904102',
    '043905135': '043905000',
    '043907125': '043907115',
    '043910160': '043910000',
    '043910161': '043910000',
    '043910165': '043910000',
    '043910213': '043910000',
    '043911107': '043911000',
    '043911111': '043911000',
    '043912165': '043912000',
    '043914101': '043914107',
    '043919101': '043919104',
    '045903106': '045903105',
    '046901102': '046901104',
    '049901101': '049901107',
    '050902102': '050902101',
    '050910105': '050910000',
    '056901104': '056901105',
    '057905102': '057905000',
    '057905200': '057905000',
    '057905204': '057905359',
    '057905285': '057905000',
    '057905300': '057905000',
    '057906107': '057906108',
    '057906113': '057906112',
    '057909180': '057909115',
    '057909181': '057909101',
    '057912161': '057912000',
    '057912162': '057912000',
    '057912163': '057912000',
    '057916119': '057916131',
    '057919101': '057919201',
    '059901107': '059901101',
    '061901114': '061901109',
    '061902141': '061902000',
    '061903101': '061903000',
    '061908102': '061908000',
    '061914110': '061914000',
    '062901104': '062901042',
    '062903103': '062903102',
    '062903105': '062903102',
    '068901106': '068901112',
    '068901115': '068901118',
    '068901134': '068901118',
    '068901136': '068901112',
    '070903106': '070903102',
    '070903107': '070903104',
    '070905103': '070905000',
    '070912113': '070912107',
    '071902186': '071902162',
    '071903105': '071903103',
    '071904102': '071904000',
    '071904103': '071904000',
    '071905134': '071905000',
    '071905147': '071905000',
    '072903101': '072903104',
    '072903102': '072903104',
    '074903103': '074903104',
    '079901117': '079901000',
    '079907158': '079907000',
    '079907161': '079907000',
    '079910101': '079910003',
    '081902101': '081902043',
    '082903104': '082903103',
    '083903103': '083903102',
    '084902117': '084902000',
    '084902501': '084902000',
    '084902502': '084902000',
    '084902503': '084902000',
    '084902504': '084902000',
    '084902505': '084902000',
    '084902506': '084902000',
    '084902507': '084902000',
    '084906109': '084906102',
    '084908104': '084908000',
    '084908106': '084908103',
    '084911101': '084911103',
    '086901104': '086901000',
    '089901101': '089901102',
    '089901104': '089901102',
    '090904111': '090904115',
    '090904118': '090904115',
    '091903103': '091903000',
    '091905101': '091905102',
    '091906100': '091906105',
    '091906101': '091906111',
    '091909110': '091909101',
    '092901102': '092901105',
    '092902106': '092902101',
    '092903111': '092903000',
    '092904103': '092904000',
    '092907103': '092907101',
    '092908102': '092908103',
    '094901101': '094901109',
    '094903101': '094903000',
    '094904101': '094904102',
    '095905125': '095905000',
    '100903101': '100903042',
    '100904105': '100904106',
    '100907101': '100907103',
    '100907102': '100907103',
    '101902104': '101902101',
    '101902151': '101902106',
    '101902153': '101902117',
    '101902154': '101902129',
    '101902161': '101902135',
    '101902162': '101902136',
    '101902163': '101902138',
    '101902164': '101902130',
    '101902165': '101902134',
    '101902166': '101902110',
    '101903130': '101903000',
    '101903131': '101903000',
    '101905107': '101905000',
    '101906102': '101906101',
    '101907159': '101907122',
    '101908106': '101908102',
    '101908109': '101908000',
    '101911117': '101911108',
    '101911127': '101911000',
    '101912131': '101912000',
    '101912209': '101912394',
    '101912350': '101912364',
    '101912352': '101912359',
    '101912354': '101912248',
    '101912355': '101912260',
    '101912357': '101912000',
    '101912360': '101912000',
    '101912470': '101912479',
    '101913131': '101913000',
    '101915130': '101915000',
    '101920128': '101920112',
    '101920130': '101920124',
    '101920131': '101920107',
    '101920132': '101920110',
    '101921100': '101921112',
    '101924107': '101924102',
    '101924110': '101924108',
    '102902110': '102902107',
    '105902109': '105902107',
    '105905102': '105905101',
    '106901103': '106901101',
    '107905101': '107905103',
    '108902104': '108902106',
    '108902111': '108902109',
    '108903106': '108903105',
    '108904132': '108904101',
    '108907110': '108907000',
    '108908121': '108908000',
    '108909131': '108909113',
    '108909135': '108909127',
    '108909137': '108909127',
    '108909138': '108909113',
    '108910102': '108910000',
    '109911101': '109911102',
    '110902106': '110902104',
    '111901104': '111901000',
    '112901107': '112901000',
    '112905102': '112905101',
    '113901105': '113901000',
    '114901110': '114901113',
    '114901111': '114901113',
    '116903101': '116903104',
    '116905109': '116905106',
    '116908102': '116908000',
    '117901104': '117901105',
    '117901106': '117901105',
    '117904103': '117904101',
    '121904105': '121904103',
    '123907111': '123907108',
    '123907117': '123907102',
    '123908112': '123908122',
    '123908113': '123908123',
    '123910132': '123910000',
    '123914101': '123914000',
    '125903101': '125903103',
    '126906101': '126906105',
    '126908102': '126908101',
    '128901107': '128901105',
    '129903105': '129903000',
    '129904101': '129904102',
    '129906103': '129906000',
    '133903107': '133903109',
    '139909105': '139909108',
    '139909111': '139909109',
    '139911101': '139911104',
    '140904103': '140904102',
    '145901102': '145901041',
    '146902102': '146902101',
    '146906102': '146906103',
    '146907101': '146907000',
    '147903103': '147903105',
    '152903101': '152903103',
    '152909101': '152909102',
    '154901101': '154901102',
    '158901101': '158901000',
    '158901104': '158901000',
    '159901103': '159901102',
    '159901112': '159901104',
    '159901116': '159901115',
    '159901119': '159901105',
    '161906106': '161906105',
    '161907102': '161907101',
    '161909102': '161909101',
    '161910102': '161910101',
    '161919101': '161919042',
    '161920105': '161920102',
    '161921106': '161921101',
    '161922101': '161922102',
    '163901101': '163901102',
    '163903102': '163903101',
    '163904102': '163904105',
    '165901136': '165901133',
    '165902101': '165902000',
    '166901104': '166901101',
    '166904101': '166904103',
    '169901043': '169901042',
    '170904109': '170904000',
    '172902102': '172902000',
    '174904103': '174904000',
    '177901102': '177901101',
    '177902101': '177902000',
    '177902105': '177902102',
    '178902102': '178902101',
    '178903104': '178903106',
    '178903105': '178903103',
    '178904153': '178904152',
    '178905103': '178905000',
    '178905105': '178905000',
    '178905109': '178905000',
    '178905201': '178905000',
    '178905202': '178905000',
    '178905203': '178905000',
    '178906105': '178906101',
    '178912101': '178912104',
    '178914103': '178914101',
    '178914106': '178914101',
    '178915102': '178915104',
    '179901101': '179901102',
    '181901102': '181901103',
    '181906104': '181906102',
    '181908101': '181908000',
    '183902104': '183902103',
    '184907107': '184907103',
    '184909102': '184909101',
    '184909103': '184909101',
    '185903102': '185903101',
    '186902104': '186902102',
    '187907103': '187907102',
    '188901110': '188901170',
    '188902103': '188902101',
    '188904101': '188904102',
    '190903101': '190903051',
    '195901101': '195901109',
    '199902109': '199902000',
    '201902107': '201902109',
    '201910104': '201910102',
    '201914105': '201914104',
    '204901102': '204901103',
    '204904101': '204904102',
    '205901101': '205901104',
    '205901105': '205901000',
    '205902106': '205902000',
    '205903102': '205903104',
    '205904101': '205904102',
    '205905103': '205905101',
    '205906103': '205906105',
    '210901104': '210901101',
    '212902103': '212902101',
    '212902104': '212902101',
    '212903104': '212903102',
    '212905124': '212905114',
    '213901101': '213901102',
    '215901101': '215901000',
    '220901107': '220901129',
    '220904105': '220904000',
    '220905221': '220905180',
    '220905228': '220905000',
    '220905258': '220905000',
    '220908127': '220908117',
    '220914104': '220914000',
    '220918005': '220918114',
    '220920103': '220920000',
    '221901156': '221901000',
    '221912101': '221912103',
    '221912106': '221912103',
    '223901101': '223901000',
    '225902105': '225902000',
    '226903119': '226903000',
    '226907104': '226907101',
    '227901177': '227901185',
    '227901194': '227901000',
    '227901196': '227901000',
    '230902104': '230902102',
    '232903102': '232903114',
    '233901108': '233901113',
    '234902101': '234902102',
    '234903101': '234903042',
    '234904101': '234904102',
    '234906101': '234906104',
    '234907102': '234907101',
    '235901103': '235901101',
    '235902129': '235902114',
    '237902103': '237902000',
    '237905106': '237905105',
    '238902108': '238902107',
    '238902109': '238902107',
    '239901106': '239901000',
    '241903107': '241903102',
    '241904102': '241904106',
    '243901104': '243901101',
    '243903103': '243903101',
    '243905104': '243905000',
    '243905210': '243905000',
    '244903105': '244903104',
    '246909140': '246909116',
    '246911107': '246911102',
    '247901108': '247901104',
    '247903103': '247903041',
    '249902104': '249902101',
    '249903101': '249903102',
    '250907103': '250907107',
    '251901104': '251901101',
    '254901101': '254901106',
  },
};

// Feeder campus a non-tested campus is paired to for the given accountability
// rating year (falls back to the most recent year on file), or null.
// Demo org pairings (fictional district 012345, never on a TEA list). Lone Star
// Elementary is PK-2, so without this its A-F report finds no tests; TEA rules
// give it North Creek Intermediate's rating. Applies to every year.
export const DEMO_PAIRED_CAMPUSES = {
  '012345101': '012345104',
};

export const getPairedCampus = (campusNumber, year) => {
  if (DEMO_PAIRED_CAMPUSES[campusNumber]) return DEMO_PAIRED_CAMPUSES[campusNumber];
  const years = Object.keys(PAIRED_CAMPUSES_BY_YEAR).sort();
  if (!years.length) return null;
  const key = year != null && PAIRED_CAMPUSES_BY_YEAR[String(year)] ? String(year) : years[years.length - 1];
  return PAIRED_CAMPUSES_BY_YEAR[key][campusNumber] || null;
};
